import { createSlice } from "@reduxjs/toolkit";

interface IConfigSliceState {
  serverAddress: string;
  serverPort: string;
}

const initialState: IConfigSliceState = {
  serverAddress: "localhost",
  serverPort: "8088",
};

export const configSlice = createSlice({
  name: "config",
  initialState: initialState,
  reducers: {
    setServerAddress: (state, action) => {
      state.serverAddress = action.payload;
      return state;
    },
    setServerPort: (state, action) => {
      state.serverPort = action.payload;
      return state;
    },
  },
});

export const getConfigPreloadState = (): IConfigSliceState => {
  const localStorageContent = localStorage.getItem("config");
  if (localStorageContent !== null) {
    try {
      const parsedContent: IConfigSliceState = JSON.parse(localStorageContent);
      return parsedContent;
    } catch (ex) {
      console.error("Unable to parse config from local storage... Using default config instead");
    }
  }

  return initialState;
}

export const configActions = configSlice.actions;
export const configSliceReducers = configSlice.reducer;
